import { Box, Typography } from "@mui/material";
import { LegalDocumentViewer } from "../../components/legal-document-viewer";
import { policyContent } from "./content";

export const PolicyPage = () => {
  return (
    <Box className="policy page">
      <LegalDocumentViewer documentContent={policyContent}>
        <Box
          sx={{
            marginLeft: "2rem !important",
          }}
        >
          <Typography variant="body1">Director of Compliance</Typography>
          <Typography variant="body1">
            Office of the Australian Information Commissioner (OAIC)
          </Typography>
          <Typography variant="body1">GPO Box 5218</Typography>
          <Typography variant="body1">Sydney NSW 2001</Typography>
          <Typography variant="body1">Phone: 1300 363 992</Typography>
          <Typography variant="body1">
            <a href="https://www.oaic.gov.au/" target="_blank" rel="noreferrer">
              https://www.oaic.gov.au/
            </a>
          </Typography>
        </Box>
        <Box
          sx={{
            marginLeft: "2rem !important",
          }}
        >
          <Typography variant={"h6"}>8. Changes to the Policy</Typography>
          <Typography variant={"body1"}>
            Company reserves the right to change this Policy from time to time,
            at its sole discretion. Company may, for example, change this Policy
            when there are changes in: its services, data protection practices,
            and/or changes in the law. Company will prompt Users to agree to a
            new Policy every time there is a change. User’s continued use of the
            Platform and/or other services provided by Company will constitute:
            (1) an acknowledgement of the new Policy, and (2) an agreement to
            abide and be bound by the new policy.
          </Typography>

          <Typography variant={"body1"} mt={1.5}>
            By accessing our platform, user agrees to be bound by all terms and
            conditions outlined above.
          </Typography>
        </Box>
      </LegalDocumentViewer>
    </Box>
  );
};
